/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import { useGLTF } from '@react-three/drei';

export function Insulation(props) {
  const { nodes, materials } = useGLTF('/InsulationTest.glb');

  // const base = useLoader(MaterialLoader, materials['Material.001'].clone);
  // console.log('scale: ', props.scale);

  // console.log('position: ', props.position);
  // console.log('multi at lamella: ', props?.multi?.lamella, ' at pos: ', props?.multi?.piece, ' - ', props?.multi);
  return (
    <group dispose={null}>
      <mesh geometry={nodes.Cube.geometry} position={props.position} material={materials['Material.002']} scale={props.scale} rotation={[0, props.rotation, 0]} />
    </group>
  );
}

useGLTF.preload('/InsulationTest.glb');
